<script lang="ts">
    import {onMount} from 'svelte';
    import type {AxiosInstance} from 'axios';

    import {getProduct} from 'general/libs/getProduct';
    import {dyData} from 'general/store';

    import s from './style.module.css';
    export let image = '';
    export let alt = '';
    export let instance: AxiosInstance;

    onMount(async () => {
        if (!instance) return null;

        if ($dyData.isLoadImage) {
            const res = await getProduct(instance, '1');
            if (res) {
                alt = res.data.items[0].name;
                image = `/ms/media${res.data.items[0].children[0].media.front.src}`;
            }
        }
    });
</script>

<div>
    <div class={s.imageContainer} class:smallScreen={$dyData.isSmallerScreen}>
        {#if image}
            <img class={s.image} src={image + '/w=460,h=212'} {alt} />
        {/if}
    </div>
</div>
